var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHupo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_25_2662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 582",
    d: "M6.87549 1.49643C5.42033 1.08067 3.92137 1.27814 3.22905 1.45745C3.13598 1.48156 3.04798 1.52324 2.9693 1.57849C1.09916 2.89146 1.14382 4.78374 1.45604 5.72041C1.77483 6.67678 2.8906 6.75648 3.36879 7.59331C3.84698 8.43013 3.28909 9.82484 3.36879 11.1399C3.44849 12.4549 4.64395 13.8496 6.15821 14.4872C7.67247 15.1247 11.7489 14.938 13.3709 13.5706C15.0328 12.1696 14.5663 9.78499 14.646 7.79255C14.7257 5.80011 13.0122 4.08661 10.5416 3.92721C8.07096 3.76781 8.82808 2.05431 6.87549 1.49643Z",
    fill: "#00C2FF",
    fillOpacity: 0.4,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_2662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHupo);
export default __webpack_public_path__ + "static/media/hupo.1ca26ac509a8bd92348f99a2a492e781.svg";
export { ForwardRef as ReactComponent };